export const getDeliveryChallanTemplate = (data, companyInfo = {}, customTermsHtml = "") => {
  const {
    invoiceNo = "",
    date = "",
    customer = "",
    customerPhone = "",

    // Billing
    billingAddressLine1 = "",
    billingAddressLine2 = "",
    billingCity = "",
    billingState = "",
    billingPincode = "",

    // Shipping / Delivery
    deliveryContactPerson = "",
    deliveryPhone = "",
    deliveryAddressLine1 = "",
    deliveryAddressLine2 = "",
    deliveryCity = "",
    deliveryState = "",
    deliveryPincode = "",

    // Items
    items = [],
    remarks = "",
    storeDetails = null
  } = data || {};

  const {
    companyName = "Space Designs",
    companyAddress = "",
    companyEmail = "",
    companyPhone = "",
    companyGst = "",
    logoUrl = "",
    digitalSignatureUrl = "",
  } = companyInfo || {};

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("en-GB");
  };

  const itemRows = (items || []).map((it, idx) => {
    const name = it.itemName || "Item";
    const qty = it.qty || 0;
    const unit = it.unit || "";
    const image = it.image || "";
    const thickness = it.thickness || "N/A";
    const quality = it.quality || "Premium";

    return `
      <tr>
        <td style="text-align:center; vertical-align:middle; font-size:8px; padding:3px 6px;">${idx + 1}</td>
        <td style="text-align:center; vertical-align:middle; padding:3px;">
          ${image ? `<img src="${image}" style="width:30px; height:30px; object-fit:contain; border-radius:4px; border:0.5pt solid #9ca3af;" />` : `<div style="width:30px; height:30px; background:#f3f4f6; border-radius:4px; margin:0 auto;"></div>`}
        </td>
        <td style="vertical-align:middle; padding:3px 8px; font-weight:600; font-size:8.5px;">${name}</td>
        <td style="text-align:center; vertical-align:middle; font-size:8px; padding:3px 6px;">${thickness}</td>
        <td style="text-align:center; vertical-align:middle; font-size:8px; padding:3px 6px;">${quality}</td>
        <td style="text-align:center; vertical-align:middle; font-weight:700; font-size:8.5px; padding:3px 8px;">${qty} ${unit}</td>
      </tr>`;
  }).join("");

  return `
  <div id="invoice-root" style="width:715px; background:#fff; border:0.5pt solid #9ca3af; box-sizing:border-box; font-family:'Inter',sans-serif; font-size:9px; color:#000; margin:0 auto; position:relative;">
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap" rel="stylesheet">
    <style>
      #invoice-root { -webkit-print-color-adjust:exact; background:#fff !important; color:#000 !important; letter-spacing:-0.1px; }
      #invoice-root * { box-sizing:border-box; }
      .lc  { width:140px; font-weight:400; padding:2px 8px !important; font-size:8.5px !important; color:#000; border:none !important; }
      .col { width:10px;  font-weight:400; padding:2px 0  !important; text-align:center; color:#000; border:none !important; font-size:8.5px !important; }
      .vc  { font-weight:600; padding:2px 8px !important; font-size:8.5px !important; color:#000; border:none !important; }
      .ht  { width:100%; border-collapse:collapse; border:none; }
      .ht td { border:none !important; padding:0 !important; }
      .st, .it { width:100%; border-collapse:collapse; margin:0; }
      .st > tbody > tr > td,
      .it > thead > tr > th,
      .it > tbody > tr > td { border:0.5pt solid #9ca3af !important; padding:2px 8px; color:#000 !important; background:#fff !important; font-size:8px !important; }
      .st td:first-child, .it th:first-child, .it td:first-child { border-left:none !important; }
      .st td:last-child,  .it th:last-child,  .it td:last-child  { border-right:none !important; }
      .st tr:first-child td, .it thead tr th { border-top:none !important; }
      .it th { font-weight:700; text-align:center; background:#f8fafc !important; border-bottom:0.5pt solid #9ca3af !important; }
      .fb { font-weight:700; }
      .tc { text-align:center; }
      .tr { text-align:right; }
    </style>

    <!-- HEADER -->
    <div style="padding:6px 15px; border-bottom:0.5pt solid #9ca3af;">
      <table class="ht">
        <tr>
          <td style="width:200px;">
            ${logoUrl ? `<img src="${logoUrl}" style="width:155px; height:50px; object-fit:contain;" />` : `<div style="font-size:16px; font-weight:700;">${companyName}</div>`}
          </td>
          <td style="text-align:right; vertical-align:middle;">
            <div style="font-size:16px; font-weight:700; letter-spacing:-0.2px;">${companyName}</div>
            <div style="margin-top:2px; line-height:1.5; font-size:10px; color:#000;">
              ${companyAddress ? companyAddress.replace(/\n/g, "<br/>") : ""}
              ${companyGst ? `<br/>GSTIN: ${companyGst}` : ""}
              ${companyEmail ? `<br/>${companyEmail}` : ""}
              ${companyPhone ? ` | ${companyPhone}` : ""}
            </div>
          </td>
        </tr>
      </table>
    </div>

    <!-- TITLE -->
    <div style="text-align:center; font-size:12px; font-weight:800; padding:4px; border-bottom:0.5pt solid #9ca3af; text-transform:uppercase; letter-spacing:0.5px;">
      DELIVERY CHALLAN
    </div>

    <!-- META DETAILS -->
    <table class="st" style="border-bottom:0.5pt solid #9ca3af;">
      <tr>
        <td style="width:50%; padding:0 !important;">
          <table style="width:100%; border-collapse:collapse; margin-bottom:6px;">
            <tr><td class="lc">Challan No.</td><td class="col">:</td><td class="vc">${invoiceNo}</td></tr>
            <tr><td class="lc">Date</td><td class="col">:</td><td class="vc">${formatDate(date)}</td></tr>
            ${storeDetails?.storeName ? `<tr><td class="lc">Store</td><td class="col">:</td><td class="vc">${storeDetails.storeName}</td></tr>` : ""}
          </table>
        </td>
        <td style="width:50%; padding:0 !important;">
          <table style="width:100%; border-collapse:collapse; margin-bottom:6px;">
            <tr><td class="lc">Customer</td><td class="col">:</td><td class="vc">${customer}</td></tr>
            ${customerPhone ? `<tr><td class="lc">Phone</td><td class="col">:</td><td class="vc">${customerPhone}</td></tr>` : ""}
          </table>
        </td>
      </tr>
    </table>

    <!-- BILLING & SHIPPING -->
    <table class="st" style="border-bottom:0.5pt solid #9ca3af;">
      <tr>
        <td style="width:50%; padding:0 !important;">
          <div style="padding:2px 8px; font-weight:700; font-style:italic; font-size:9px;">Billed To :</div>
          <table style="width:100%; border-collapse:collapse; margin-bottom:6px;">
            <tr><td class="lc">Name</td><td class="col">:</td><td class="vc">${customer}</td></tr>
            ${billingAddressLine1 ? `<tr><td class="lc">Address</td><td class="col">:</td><td class="vc">${billingAddressLine1}${billingAddressLine2 ? ", " + billingAddressLine2 : ""}</td></tr>` : ""}
            ${billingCity ? `<tr><td class="lc">City</td><td class="col">:</td><td class="vc">${billingCity}</td></tr>` : ""}
            ${billingState ? `<tr><td class="lc">State</td><td class="col">:</td><td class="vc">${billingState}</td></tr>` : ""}
            ${billingPincode ? `<tr><td class="lc">Pincode</td><td class="col">:</td><td class="vc">${billingPincode}</td></tr>` : ""}
            ${customerPhone ? `<tr><td class="lc">Mobile</td><td class="col">:</td><td class="vc">${customerPhone}</td></tr>` : ""}
          </table>
        </td>
        <td style="width:50%; padding:0 !important; border-left:0.5pt solid #9ca3af;">
          <div style="padding:2px 8px; font-weight:700; font-style:italic; font-size:9px;">Shipped To :</div>
          <table style="width:100%; border-collapse:collapse; margin-bottom:6px;">
            <tr><td class="lc">Name</td><td class="col">:</td><td class="vc">${deliveryContactPerson || customer}</td></tr>
            ${deliveryAddressLine1 ? `<tr><td class="lc">Address</td><td class="col">:</td><td class="vc">${deliveryAddressLine1}${deliveryAddressLine2 ? ", " + deliveryAddressLine2 : ""}</td></tr>` : ""}
            ${deliveryCity ? `<tr><td class="lc">City</td><td class="col">:</td><td class="vc">${deliveryCity}</td></tr>` : ""}
            ${deliveryState ? `<tr><td class="lc">State</td><td class="col">:</td><td class="vc">${deliveryState}</td></tr>` : ""}
            ${deliveryPincode ? `<tr><td class="lc">Pincode</td><td class="col">:</td><td class="vc">${deliveryPincode}</td></tr>` : ""}
            ${deliveryPhone ? `<tr><td class="lc">Mobile</td><td class="col">:</td><td class="vc">${deliveryPhone}</td></tr>` : ""}
          </table>
        </td>
      </tr>
    </table>

    <!-- ITEMS TABLE -->
    <table class="it" style="table-layout:fixed; width:100%;">
      <thead>
        <tr>
          <th style="width:30px; text-align:center !important; font-size:8.5px !important; padding:3px 6px;">S.No.</th>
          <th style="width:50px; text-align:center !important; font-size:8.5px !important; padding:3px 6px;">Image</th>
          <th style="text-align:left !important; font-size:8.5px !important; padding:3px 8px;">Item Description</th>
          <th style="width:80px; text-align:center !important; font-size:8.5px !important; padding:3px 6px;">Thickness</th>
          <th style="width:80px; text-align:center !important; font-size:8.5px !important; padding:3px 6px;">Quality</th>
          <th style="width:70px; text-align:center !important; font-size:8.5px !important; padding:3px 6px;">Quantity</th>
        </tr>
      </thead>
      <tbody>
        ${itemRows || `<tr><td colspan="6" style="text-align:center; padding:10px; font-size:8px; color:#888;">No items found</td></tr>`}
      </tbody>
    </table>

    <!-- REMARKS / NOTES -->
    ${remarks ? `
    <div style="border-top:0.5pt solid #9ca3af; padding:6px 10px;">
      <div style="font-weight:700; font-size:8.5px; margin-bottom:3px; text-transform:uppercase; letter-spacing:0.3px; color:#374151;">Notes / Remarks</div>
      <div style="font-size:8.5px; line-height:1.6; color:#1f2937; background:#f9fafb; border:0.5pt solid #e5e7eb; border-radius:3px; padding:5px 8px; white-space:pre-line;">${remarks}</div>
    </div>` : ""}

    <!-- FOOTER -->
    <table class="st" style="table-layout:fixed; width:100%; border-top:0.5pt solid #9ca3af;">
      <tr>
        <td style="width:60%; padding:6px 8px !important; vertical-align:top; border-right:0.5pt solid #9ca3af;">
          <div style="font-weight:700; font-size:8.5px; border-bottom:0.5pt solid #9ca3af; padding-bottom:2px; margin-bottom:4px;">Terms &amp; Conditions</div>
          <div style="font-size:8px; line-height:1.4; color:#333;">
            ${customTermsHtml || `
            <div>1. Delivery timeline is subject to site readiness.</div>
            <div>2. Goods once delivered will not be taken back without proper authorization.</div>
            <div>3. All disputes subject to local jurisdiction only.</div>
            <div>4. E &amp; O.E.</div>
            `}
          </div>
        </td>
        <td style="width:40%; padding:6px 8px !important; vertical-align:top; text-align:center;">
          ${digitalSignatureUrl ? 
            `<div style="margin-top:5px; margin-bottom:5px; display:flex; justify-content:center; align-items:center;"><img src="${digitalSignatureUrl}" style="height:35px; object-fit:contain;" /></div>` : 
            `<div style="margin-top:45px;"></div>`
          }
          <div style="border-top:0.5pt solid #9ca3af; padding-top:4px; font-size:8px; font-weight:600; text-align:center;">
            Authorized Signatory
          </div>
        </td>
      </tr>
    </table>
  </div>`;
};
